export class ApiEndPointsCore {
    getCoreListing = 'api/Core/GetCores';
    getFavoriteCoreListing = 'api/CoreFavorite/GetFavoriteCores';
    getCoreImportantList = 'api/CoreFavorite/GetImportantCores';
    getCoreFeildList = 'api/Core/GetAllFolderFields';
    getContactFeildList = 'api/Core/GetAllFolderFields';
    getCompanyFeildList = 'api/Core/GetAllFolderFields';
    saveCoreFieldList = 'api/Core/AddCore';
    AddTaskCustomField = 'api/Task/AddTaskCustomField';
    saveContactFieldList = 'api/Contact/AddContact';
    saveCompanyFieldList = 'api/Company/AddCompany';
    RemoveGroupRelation = 'api/Project/RemoveGroupRelation';
    GetAttachedEntityDocumentFolders = 'api/Task/GetAttachedEntityDocumentFolders';
    saveCoreUserDetails = 'api/Core/UpdateCore';
    submit_prompt_4o_onGivenContext_New = 'api/Core/submit_prompt_4o_onGivenContext';
    GetTaskCustomFields = 'api/Task/GetTaskCustomFields';
    UpdateTaskCustomFields = 'api/Task/UpdateTaskCustomFields';
    saveContactUserDetails = 'api/Contact/UpdateContact';
    saveCompanyUserDetails = 'api/Company/UpdateCompany';
    getCoreUserDetails = 'api/Core/GetCoreDetail';
    getPaychexWorkerCommunication = 'api/Core/SyncWorkerCommunications';
    getContactUserDetails = 'api/Contact/GetContactDetail';
    getCompanyUserDetails = 'api/Company/GetCompanyDetail';
    getCoreFieldColumn = 'api/CustomizedGridComponent/GetUserGridCustomizedSetting';
    updateCoreFieldColumn = 'api/CustomizedGridComponent/UpdateUserGridCustomizationSetting';
    ReorderCoreFieldColumn = 'api/CustomizedGridComponent/ReorderColumn';
    getImageUploadURL = 'api/App/UploadProfilePic';
    searchTransCities = 'api/app/SearchCities';
    getDefaultFilterFieldsList = 'api/Filter/GetDefaultFilterFields';
    CreateFilter = 'api/Filter/AddFillter';
    GetAllFillters = 'api/Filter/GetAllFillters';
    GetFilteredCores = 'api/Core/GetFilteredCores';
    DeleteCoreTransaction = 'api/Core/DeleteCore';
    FavoriteCoreTransaction = 'api/CoreFavorite/AddCoreFavorite';
    ImportantCoreTransaction = 'api/CoreFavorite/AddCoreImportant';
    FavoriteDeleteCoreTransaction = 'api/CoreFavorite/DeleteCoreFavorite';
    ImportantDeleteCoreTransaction = 'api/CoreFavorite/DeleteImportantCore';
    searchTransZip = 'api/app/SearchZipCode';
    getStateList = 'api/Orgnization/GetStateValues';
    MakeFilterFavorite = 'api/Filter/MakeFilterDefault';
    getCoreRecentFilter = 'api/Filter/RecentFilter';
    GetUserPreferences = 'api/Auth/GetUserPreferences';
    AddPrefrences = 'api/Auth/AddPreferences';
    RemoveSelectedFilter = 'api/Filter/DeleteFillters';
    AddCoreTouch = 'api/CoreTouch/AddCoreTouch';
    AddContactTouch = 'api/ContactTouch/AddContactTouch';
    AddCompanyTouch = 'api/CompanyTouch/AddCompanyTouch';

    DeleteAllergyByIDs = 'api/Core/DeleteAllergyByIDs';
    AddUpdateAllergyByID = 'api/Core/AddUpdateAllergy';
    GetAllAllergyList = 'api/Core/GetAllAllergyList';


    GetAllImmunizationList = 'api/Core/GetAllImmunizationList';
    AddUpdateImmunizationByID = 'api/Core/AddUpdateImmunization';
    DeleteImmunizationByIDs = 'api/Core/DeleteImmunizationByIDs';

    AddAllergiesPCC = "api/Core/AddAllergiesPCC";
    AddImmunizationsPCC = "api/Core/AddImmunizationsPCC";
    AddConditionsPCC = "api/Core/AddConditionsPCC";
    AddObservationPCC = "api/Core/AddObservationPCC";
    // API Address mapping
    GetAllObservationList = 'api/Core/GetAllObservationList';
    AddUpdateObservationByID = 'api/Core/AddUpdateObservation';
    DeleteObservationByIDs = 'api/Core/DeleteObservationByIDs';

    AddUpdateConditionID = "api/Core/AddUpdateCondition";
    GetAllConditionList = 'api/Core/GetAllConditionList';
    DeleteConditionByIDs = 'api/Core/DeleteConditionByIDs';

    UpdateCoreTouch = 'api/CoreTouch/UpdateCoreTouch';
    UpdateContactTouch = 'api/ContactTouch/UpdateContactTouch';
    UpdateCompanyTouch = 'api/CompanyTouch/UpdateCompanyTouch';
    DeleteCoreTouch = 'api/CoreTouch/DeleteCoreTouch';
    DeleteContactTouch = 'api/ContactTouch/DeleteContactTouch';
    DeleteCompanyTouch = 'api/CompanyTouch/DeleteCompanyTouch';
    AddTouchTypeName = 'api/App/AddTouchType';
    GetAllCoreTouches = 'api/CoreTouch/GetAllCoreTouches';
    AddFormTouch = 'api/FormTouch/AddFormTouch';
    GetDocumentDetails = 'api/CoreDocument/GetDocumentDetails';
    MakeDocumentRequired = 'api/CoreDocument/MakeDocumentRequired';
    RenameProjectName = 'api/Project/RenameProjectName';
    ChangeDocumentStatus = 'api/CoreDocument/ChangeDocumentStatus';
    ChangeStatusCoreDocumentByReviewer = 'api/CoreDocument/ChangeStatusCoreDocumentByReviewer';
    GetRelationsForSelectedCores = 'api/Core/GetRelationsForCoreIds';
    SendBroadcastMsgToRelations = 'api/Core/SendBoradCastMessage';

   	getClinicalTemplateCategories = "api/Core/GetClinicalTemplateCategories";
    getClinicalTemplateMedication = "api/Core/GetClinicalTemplateMedication";
    addClinicalTemplate = "api/Core/AddClinicalTemplate";
    updateClinicalTemplate = "api/Core/UpdateClinicalTemplate";
    updateCoreTemplateMedications = "api/Core/UpdateCoreTemplateMedications";
    addClinicalTemplateCategory = "api/Core/AddClinicalTemplateCategory";
    getClinicalTemplates = "api/Core/getClinicalTemplates";
    
    ManageFormTemplateCategory = "api/Project/ManageFormTemplateCategory";
    SearchSubjectTemplate = "api/App/SearchSubjectTemplate";
    AddUpdateSubjectMessageTemplate = "api/App/AddUpdateSubjectMessageTemplate";
    CheckProjectName = "api/Project/CheckProjectName";
    GetCCCHtmlFormData = "api/Project/GetCCCHtmlFormData";
    addTask = "api/Task/AddTask";
    getTaskDetailByID = "api/Task/GetTaskDetailByID";
    updateTaskDetail = "api/Task/UpdateTaskDetail";
    removeSubTasks = "api/Task/RemoveSubTasks";
    removeTasks = "api/Task/RemoveTasks";
    AddCoreMultiDocument = 'api/CoreDocument/AddCoreMultiDocument';
    AddContactMultiDocument = "api/ContactDocument/AddContactMultiDocument"
    AddCompanyMultiDocument = "api/CompanyDocument/AddCompanyMultiDocument";
    AddTaskMultiDocument = "api/task/AddTaskMultiDocument";
    DeleteUploadedDocuments = "api/Task/DeleteUploadedDocuments";
    taskStatus = "api/TaskStatus/GetTaskStatuses";//"api/TaskStatus/GetOfficeTaskStatuses";

    AddTaskCoreURL = "api/core/AddTaskCore";
    AddTaskContactURL = "api/contact/AddTaskContact";
    AddTaskCompanyURL = "api/company/AddTaskCompany";

    AddSavedURL = "api/CoreDocument/AddUrlforPlaceholder";

    sendToPaychex = 'api/Core/SendToPaychex';
    sendToPendingPatientPCC = 'api/Core/SendToPendingPatientPCC';
    sendToPCC = 'api/Contact/SendToPCC';
    sendToPCCCompany = 'api/Company/sendToPCC';
    manageFormTemplateOrganizationCategory = "api/Project/ManageFormTemplateOrganizationCategory";
    getTaskLists = "api/TaskList/GetTaskLists";
    GetTaskGroupsByTaskList = "api/Task/GetTaskGroupsByTaskList";
    addTaskTemplateCategory = "api/TaskTemplate/AddTaskTemplateCategory";
    syncAllWorker = 'api/Core/SyncAllWorker';
    setCoreArchive = "api/Core/SetCoreArchive";
    setCoreActivate = "api/Core/SetCoreActivate";
    updateTaskListGridCustomizedSetting = 'api/CustomizedGridComponent/UpdateTaskListGridCustomizedSetting';
    addUserKanbanView = "api/Core/AddUserKanbanView";
    changeCoreStatus = "api/Core/ChangeCoreStatus";
    getCoreFieldValue = "api/Core/GetCoreFieldValue";

    addActivityForPortal = "portalapi/Portal/AddActivity";
    getAllToucheStatus = "api/CoreTouch/GetAllToucheStatus";
    addTouchStatus = "api/CoreTouch/AddTouchStatus";
    addOCRTemplateCategory = "api/OCRTemplate/AddOCRTemplateCategory";
    SendActivityEMailCore = "api/CoreTouch/SendActivityEMail";
    SendActivityEMailContact = "api/ContactTouch/SendActivityEMail";
    SendActivityEMailCompany = "api/CompanyTouch/SendActivityEMail";
    getAllTagList = 'api/app/GetAllTags';
    getAllFolderFields = 'api/Core/GetAllFolderFields';
    addTicketTask = "api/Task/AddTicketTask";
    getOfficeMailConfigration = "api/Orgnization/GetOfficeMailConfigration";
    addNLPTemplateCategory = "api/NLPTemplate/AddNLPTemplateCategory";

    getHtmlFormData = "api/Project/GetHtmlFormData";
    addCustomInfoStatus = "api/CustomInfo/AddCustomInfoStatus";
    addCustomInfo = "api/CustomInfo/AddCustomInfo";
    updateCustomInfo = "api/CustomInfo/UpdateCustomInfo";
    deleteCustomInfo = "api/CustomInfo/DeleteCustomInfo";
    addCustomNoteType = "api/CustomInfo/AddCustomNoteType";
    getAllCustomInfoStatus = "api/CustomInfo/GetAllCustomInfoStatus"
    addFileManagerTouch = "api/FileManagerTouch/AddFileManagerTouch";
    addWebFormUserSetting = "api/Project/AddWebFormUserSetting";
    unMappedTouchesTypes = "api/App/UnMappedTouchesTypes";
    unMappedtCustomInfoTypes = "api/CustomInfo/UnMappedtCustomInfoTypes";
    renamecoreplaceholder = "api/CoreDocument/RenameCorePlaceholder";
    GetAllContactTouches = 'api/ContactTouch/GetAllContactTouches';
    GetAllCompanyTouches = 'api/CompanyTouch/GetAllCompanyTouches';
    getDashboardProcessStages = "api/Dashboard/GetDashboardProcessStages";
    getAllActiveStages = "api/Dashboard/GetAllActiveStages";
    setProcessStageforTaskTemplate = "api/TaskTemplate/SetProcessStageforTaskTemplate";
    setProcessStagetoDocumentFolderTemplate = "api/DocumentTemplate/SetProcessStagetoDocumentFolderTemplate";
    setProcessStageforTasklistGroup = "api/TaskList/SetProcessStageforTasklistGroup";
    setProcessStageForCoreDocumentFolder = "api/CoreDocument/SetProcessStageForCoreDocumentFolder";
    reorderTaskGroup = "api/Task/ReorderTaskGroup";
    removeTaskGroup = "api/TaskList/RemoveTaskGroup";
    addEditTaskGroup = "api/TaskList/AddEditTaskGroup";
    UpdateTaskStatus = "api/Task/UpdateTaskStatus";
    makeTaskRequired = "api/Task/MakeTaskRequired";
    UpdateSingleTaskStatus = "api/Task/UpdateSingleTaskStatus";
    UpdateTaskOrTaskListstatus = "api/Task/UpdateTaskOrTaskListstatus";
    UpdateTaskPriority = "api/Task/UpdateTaskPriority";
    archivedTask = "api/Task/ArchivedTask";
    deleteMedicationByIDs = "api/Core/DeleteMedicationByIDs";
    sendManualReminderforTask = "api/Task/SendManualReminderforTask";
    getNormalAndSharedContacts = 'api/Contact/GetCoreSelectedContact';
    AddCreateProjectforPlaceholder = "api/CoreDocument/AddCreateProjectforPlaceholder";
    AddProjectInfoAsTemplete = "api/Project/AddProjectInfoAsTemplete";
    AddProjectEventLog = "api/Project/AddProjectEventLog";
    AddEditProjectGroupRelationParticipant = 'api/Project/AddEditProjectGroupRelationParticipant';
    getAIAutomationTemplates="api/AIAutomation/GetAIAutomationTemplates";
    sendCoreEducationalMaterialToContacts="api/AIAutomation/SendCoreEducationalMaterialToContacts";
    getConditionsForCore="api/AIAutomation/GetConditionsForCore";
    getCoreEducationalMaterial="api/AIAutomation/GetCoreEducationalMaterial";
    preparePersonalMessage="api/AIAutomation/PreparePersonalMessage";
    runAutomationForAIToolForClinical="api/Core/RunAutomationForAIToolForClinical";
    uploadChunk = "api/FileManager/UploadChunk";
    uploadChunkForMultipleUploadWithSelectedTemplate="api/FileManager/UploadChunkForMultipleUploadWithSelectedTemplate";
    getInboxProjects = "api/Project/GetInboxProjects";
    getSentProjects = "api/Project/GetSentBoxItems";
    getDraftedProjects = "api/Project/GetDraftedProjects";
    changeMedicalCategoryForCore="api/PDPM/ChangeMedicalCategoryForCore";
    changeProcessStageForCore = "api/Dashboard/ChangeProcessStageForCore";
    uploadChunkForMultipleFiles="api/FileManager/UploadChunkForMultipleFiles";
    addIncomeForPDPMCore="api/PDPMAccounting/AddIncomeForPDPMCore";
    addAssetForPDPMCore="api/PDPMAccounting/AddAssetForPDPMCore";
    addExpenseForPDPMCore="api/PDPMAccounting/AddExpenseForPDPMCore";
    getAccountingforPDPMCore="api/PDPMAccounting/GetAccountingforPDPMCore";
    removeIncomeforPDPMCore="api/PDPMAccounting/RemoveIncomeforPDPMCore";
    removeAssetforPDPMCore="api/PDPMAccounting/RemoveAssetforPDPMCore";
    removeExpenseforPDPMCore="api/PDPMAccounting/RemoveExpenseforPDPMCore";
    addPNAadResourceLimit="api/PDPMAccounting/AddPNAadResourceLimit";
    addReferralTemplateCategory="api/ReferralTemplate/AddReferralTemplateCategory";
    getReferralTemplateCategories="api/ReferralTemplate/GetReferralTemplateCategories";
    addUpdateThresholdRules="api/ReferralTemplate/AddUpdateThresholdRules";
    getThresholdRules = "api/ReferralTemplate/GetThresholdRules";
    addReferralTemplate="api/ReferralTemplate/AddReferralTemplate";
    getReferralTemplates="api/ReferralTemplate/GetReferralTemplates";
    importReferralTemplateFromAOffice="api/ReferralTemplate/ImportReferralTemplateFromAOffice";
    updateReferralTemplate="api/ReferralTemplate/UpdateReferralTemplate";
    updateThresholdRule="api/ReferralTemplate/UpdateThresholdRule";
    updateThresholdRules="api/ReferralTemplate/UpdateThresholdRules";
    importReferralQuestionsFromTemplate="api/ReferralTemplate/ImportReferralQuestionsFromTemplate";
    getReferralQuestionAnswers="api/ReferralTemplate/GetReferralQuestionAnswers";
    getActiveReferralLocations="api/ReferralTemplate/GetActiveReferralLocations";
    associateLocationWithReferralQueue="api/ReferralTemplate/associateLocationWithReferralQueue";
    canThisPdfOpenforModifyByBytes="api/App/CanThisPdfOpenforModifyByBytes";
    getCoreSelectedCores="api/Core/GetCoreSelectedCores";
    getNormalAndSharedCompanys = 'api/Company/GetCoreSelectedCompany';
    addUpdateCoresToCore="api/Core/AddUpdateCoresToCore";
    addUpdateCoreContact = 'api/Contact/addUpdateCoreContact';
    addUpdateCoreCompany = 'api/Company/addUpdateCoreCompany';
    addProjectRequests="api/Project/AddProjectRequests";
    getAllParticipantsForProjects="api/Project/GetAllParticipantsForProjects";
    addParticipantsForProjects="api/Project/AddParticipantsForProjects";
    addUpdateCoreContactRole = "api/Contact/AddUpdateCoreContactRole";
    addUpdateCoreCompanyRole = "api/Company/AddUpdateCoreCompanyRole";
    addMemoryCardCategory="api/ReferralTemplate/AddMemoryCardCategory";
    getMemoryCardCategories="api/ReferralTemplate/GetMemoryCardCategories";
    addMemoryCard="api/ReferralTemplate/AddMemoryCard";
    getMemoryCards="api/ReferralTemplate/GetMemoryCards";
    addMemoryCardToReferralQuestion="api/ReferralTemplate/AddMemoryCardToReferralQuestion";
    addFileNote="api/FileManager/AddFileNote";
    deleteFileNote="api/FileManager/DeleteFileNote";
    GetContactListCoreImplementation = 'api/Contact/GetContactListCoreImplementation';
}